// extracted by mini-css-extract-plugin
export var searchHeader = "_ag-0";
export var searchHeaderDark = "_ag-1";